import Urls from './urls';
import BaseUrls from './baseUrls';

export const prefixPath = (src: string): string => {
  if (process.env.REACT_APP_SUB_PATH !== '' && process.env.REACT_APP_SUB_PATH !== undefined) {
    return process.env.REACT_APP_SUB_PATH + src;
  }
  return src;
};
export const removeHighlight = (x: any, type: 'border' | 'heading') => {
  const t = x;
  if (t) {
    if (type === 'border') t.current.style.borderColor = '#ced4da';
    else t.current.style.color = 'black';
  }
};

export const highlight = (x: any, type: 'border' | 'heading') => {
  const t = x;
  if (t) {
    if (type === 'border') t.current.style.borderColor = 'red';
    else t.current.style.color = 'red';
  }
};

export const formatCurrency = (
  value: number,
  currency?: 'INR' | 'AED' | 'USD' | 'EUR' | 'RUB',
): string => new Intl.NumberFormat(
  'en-IN',
  currency ? { style: 'currency', currency } : {},
).format(value || 0);

export const getItemCodeMap = () => {
  const map: { [key: string]: string } = {};
  const itemCodes = Urls.getItemCodes();
  Object.keys(itemCodes).forEach((key: string) => {
    map[itemCodes[key]] = key;
  });
  return map;
};

export const breadcrumbPath = (src: string): { name: string; path: string }[] => {
  const path_one = localStorage.getItem('workspaceName') || '';

  const path_url = localStorage.getItem('workspace_url') || '';

  let path: { name: string; path: string }[] = [];

  if (src === 'fullnode') {
    path = [
      { name: 'Home', path: BaseUrls.getPlatformDashboardUrl() },
      { name: 'Networks', path: BaseUrls.getPlatformManageDedicatedNodesUrl() },
    ];
  } else if (src === 'validatornode') {
    path = [
      { name: 'Home', path: BaseUrls.getPlatformDashboardUrl() },
      { name: 'Networks', path: BaseUrls.getPlatformManageStakingNodesUrl() },
    ];
  } else if (src === 'workspace') {
    path = [
      { name: 'Workspaces', path: BaseUrls.getPlatformWorkspaceUrl() },
      { name: path_one, path: `${BaseUrls.getPlatformWorkspaceUrl()}/${path_url}` },
    ];
  }

  return path;
};
